import gccApiClient from '../clients/gccApiClient/gccApiClient';
import { createFileFromUrl } from './fileHelper';

export default async (assignment) => {
  const fileName = `${assignment.channelName}_${Date.now()}.png`;
  const fileType = 'image/png';
  const file = await createFileFromUrl(assignment.channelImage, fileName, fileType);
  const { imageUrl: newImageUrl } = await gccApiClient.uploadMedia(fileName, file);
  return encodeURI(newImageUrl);
};
